import React, { useMemo } from "react";
import { Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import { ASSET_NAME } from "../../assets";

const BackgroundTexture = ({ dimensions, type }) => {
  const textureUrl = useMemo(() => {
    if (type === "main") {
      return dimensions.width < dimensions.height
        ? ASSET_NAME.mainBackgroundPortrait
        : ASSET_NAME.mainBackgroundLandscape;
    } else if (type === "feature") {
      return dimensions.width < dimensions.height
        ? ASSET_NAME.featureBackgroundPortrait
        : ASSET_NAME.featureBackgroundLandscape;
    }
  }, [dimensions.width, dimensions.height, type]);

  const texture = PIXI.Assets.get(textureUrl);

  if (!texture) return null;

  return (
    <Sprite
      texture={texture}
      anchor={0.5}
      x={dimensions.width / 2}
      y={dimensions.height / 2}
      width={dimensions.width}
      height={dimensions.height}
      zIndex={1}
    />
  );
};

export default BackgroundTexture;
